// extracted by mini-css-extract-plugin
export default {"form":"NewRequestIntro-module__form--Zg9VI","heading":"NewRequestIntro-module__heading--ukoEY"};